import React from 'react'
import styled, { th } from '@xstyled/styled-components'

const StyledContent = styled.div`
  color: #e0ddd8;
  font-size: 18px;
  line-height: 1.75;

  h2,
  h3,
  h4 {
    color: ${th.color('lime')};
    font-weight: 600;
    letter-spacing: -0.01em;
  }

  h2 {
    font-size: 1.5em;
    margin-top: 2.5em;
    margin-bottom: 0.8em;
    line-height: 1.25;
  }

  h3 {
    font-size: 1.2em;
    margin-top: 2em;
    margin-bottom: 0.6em;
    line-height: 1.3;
  }

  h4 {
    font-size: 1em;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
  }

  p {
    margin-bottom: 1.5em;
  }

  a {
    color: ${th.color('grassGreen')};
    text-decoration: underline;
    text-underline-offset: 2px;
    &:hover {
      color: ${th.color('lightGreen')};
    }
  }

  strong {
    color: ${th.color('grandMontezuma')};
    font-weight: 600;
  }

  ul,
  ol {
    margin-bottom: 1.5em;
    padding-left: 1.25em;
  }

  li {
    margin-bottom: 0.6em;
    padding-left: 0.25em;
  }

  li::marker {
    color: ${th.color('wind')};
  }

  blockquote {
    border-left: 3px solid ${th.color('grassGreen')};
    margin: 2em 0;
    padding: 0.75em 1.25em;
    color: ${th.color('vandog')};
    font-style: italic;
    background: rgba(255, 255, 255, 0.02);
    border-radius: 0 6px 6px 0;
  }

  code {
    background: rgba(255, 255, 255, 0.08);
    padding: 0.15em 0.4em;
    border-radius: 4px;
    font-size: 0.85em;
    font-family: 'SF Mono', 'Fira Code', monospace;
  }

  pre {
    background: rgba(0, 0, 0, 0.35);
    padding: 1.25em 1.5em;
    border-radius: 8px;
    overflow-x: auto;
    margin: 2em 0;
    border: 1px solid rgba(255, 255, 255, 0.06);

    code {
      background: none;
      padding: 0;
      font-size: 0.875em;
      line-height: 1.6;
    }
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 2em 0;
    display: block;
  }

  hr {
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    margin: 3em 0;
  }
`

export function BlogContent({ html }) {
  return <StyledContent dangerouslySetInnerHTML={{ __html: html }} />
}
